/**
 * Formata data para exibição
 */
export function formatDate(date) {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(date));
}

/**
 * Converte uma data/hora UTC para o timezone da empresa e formata para exibição
 * @param {string|Date} dateTime - Data/hora em UTC (string ISO ou Date)
 * @param {string} timeZoneId - ID do timezone (ex: 'America/Sao_Paulo')
 * @returns {string} Data/hora formatada no timezone da empresa
 */
export function formatDateTimeInTimeZone(dateTime, timeZoneId = 'America/Sao_Paulo') {
  if (!dateTime) return 'N/A';
  
  const date = typeof dateTime === 'string' ? new Date(dateTime) : dateTime;
  
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timeZoneId
  }).format(date);
}

